import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ButtonColorsEnum } from '@shared/enums';
import { ModalOverlayService } from '@features/overlay/services';
import { ClickOutsideDirective } from '../../../../shared/directives/click-outside/click-outside.directive';
import { CloseButtonComponent } from '../../../../shared/components/close-button/close-button.component';
import { ButtonComponent } from '../../../forms/button/button.component';

@Component({
  selector: 'confirmation-overlay',
  templateUrl: './confirmation-overlay.component.html',
  styleUrls: ['./confirmation-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ClickOutsideDirective, CloseButtonComponent, ButtonComponent],
})
export class ConfirmationOverlayComponent {
  @Input()
  public title: string;

  public ButtonColorsEnum = ButtonColorsEnum;

  constructor(private readonly overlayService: ModalOverlayService) {}

  /**
   * Stop bubbling to document:click and defer the close to the next tick.
   * setTimeout(0) prevents the underlying clickOutside/document handlers from
   * treating this click as an outside click after the overlay DOM is removed.
   */
  public onConfirm(event?: MouseEvent): void {
    event?.stopPropagation();
    setTimeout(() => this.overlayService.closeModal(true), 0);
  }

  /** See onConfirm for rationale about stopPropagation and deferring with setTimeout(0). */
  public onCancel(event?: MouseEvent): void {
    event?.stopPropagation();
    setTimeout(() => this.overlayService.closeModal(false), 0);
  }

  /** See onConfirm for rationale about stopPropagation and deferring with setTimeout(0). */
  public onCloseModal(event?: Event): void {
    event?.stopPropagation();
    setTimeout(() => this.overlayService.closeModal(null), 0);
  }

  public onClickOutside(): void {
    this.overlayService.closeModal(null);
  }
}
